import React, { useState } from "react";
import { Activity, ActivityFeed } from "@ofqual/portal-activity-feed";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { ActivityType, allActivityTypes } from "../../../domain/ActivityType";
import {
  ActionType,
  EventNotificationActivityFeedProps,
} from "./EventNotificationActivityFeedTypes";
import { FilterCheckbox } from "@ofqual/portal-components/components/ResponseFilter";
import { UserType } from "../../../redux/types";
import { buildDefinitions } from "./buildDefinitions";
import { buildActions } from "./buildActions";
import { renderDialog } from "./renderDialog";
import { useEffect } from "react";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { authSelector } from "../../../redux/selectors";

export const EventNotificationActivityFeed: React.FC<EventNotificationActivityFeedProps> = ({
  eventNotification,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<
    ActionType | Activity | null
  >(null);
  const [excludeChecked, setExcludeChecked] = useState(true);
  const { userType } = useAuth(authSelector);

  const isMagiclinkUser = userType === UserType.Magic;

  const definitions = buildDefinitions(eventNotification, (activity) =>
    setFocussedEntity(activity)
  );

  const menuActions = buildActions(
    !isMagiclinkUser,
    !isMagiclinkUser,
    (entity) => setFocussedEntity(entity)
  );

  const defaultExcludeActivityTypes = {
    activityTypes: [
      ActivityType.EventNotificationMessageOfqual,
      ActivityType.EventNotificationMessageAo,
      ActivityType.EventNotificationDocumentOfqual,
      ActivityType.EventNotificationDocumentAo,
    ],
  };

  const [filterCount, setFilterCount] = useState(1);
  const [params, setParams] = useState<QueryParams | undefined>(
    defaultExcludeActivityTypes
  );
  useEffect(() => {
    if (userType === UserType.Magic) {
      setParams(undefined);
    }
  }, [userType]);

  return (
    <>
      <ActivityFeed
        resourceId={eventNotification?.id}
        params={params}
        definitions={definitions}
        actions={menuActions}
        activeFilters={filterCount}
      >
        {(workingParams, dirtyParams, addParam) => (
          <>
            {!isMagiclinkUser ? (
              <FilterCheckbox
                isChecked={excludeChecked}
                name="activityTypes"
                text="Exclude updates"
                dataTest="exclude-updates-checkbox"
                onChange={(e) => {
                  let newActivityTypes = allActivityTypes;
                  if (e && e.target.checked) {
                    newActivityTypes =
                      defaultExcludeActivityTypes.activityTypes;
                    setFilterCount(filterCount + 1);
                  } else {
                    newActivityTypes =
                      userType === UserType.AO
                        ? allActivityTypes.filter(
                            (x) =>
                              x !==
                              ActivityType.EventNotificationOfqualDetailsUpdated
                          )
                        : allActivityTypes;
                    setFilterCount(filterCount - 1);
                  }
                  setParams({ activityTypes: newActivityTypes });
                  addParam("activityTypes", newActivityTypes);
                  if (e) setExcludeChecked(e.target.checked);
                }}
              />
            ) : null}
          </>
        )}
      </ActivityFeed>
      {renderDialog(eventNotification, focussedEntity, () =>
        setFocussedEntity(null)
      )}
    </>
  );
};
